
export default {
  data() {
    return {
      title: "Shipping Policy | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
